import { FacetCategory, Facet } from 'services/api/entities/catalog/facets'
import { useKGetList } from 'services/hooks/useKGetList'
import { alphaNumericSorter } from 'services/utils'
import { FacetFilterGroup } from 'types/form'

function useFacets<T extends Facet = Facet>(
  facetCategory: Omit<FacetCategory, 'filterTag'>,
  filterGroup?: FacetFilterGroup
): T[] {
  const facets = useKGetList<T>('facets')
    .filter((f) => f.category === facetCategory)
    .filter((f) => f.filterGroup === filterGroup)

  const sortedByDescription = facets.sort(
    alphaNumericSorter<T>((f) => f.description)('ASC')
  )
  return sortedByDescription
}

export default useFacets
